import { Inject, Injectable } from "@webmotors/ioc";
import { LOGGER, type Logger } from "../logger";
import { InsiderObjectDTO, InsiderUserDTO } from "./dtos";
import { window } from "@packages/global";

export type InsiderEventParams = {
  event: string;
  properties: Record<string, any>;
};

export type InsiderTagParams = {
  properties?: Record<string, any>;
  user: InsiderUserDTO;
  cookieConfig: Record<string, any>;
};

@Injectable("InsiderTagService")
export class InsiderTagService {
  private logger: Logger;

  constructor(@Inject(LOGGER) private loggerFactory: Logger) {
    this.logger = this.loggerFactory.create("InsiderTagService");
  }

  createInsiderObject(params: InsiderTagParams): void {
    this.logger.log("[Create] insider object: ", params);
    const { user, properties, cookieConfig } = params;
    const { showCookieNotice, cookies } = cookieConfig;
    const gdprOptin: boolean | null = !showCookieNotice && cookies
      ? Object.values(cookies).some((value) => value === true)
      : null;

    const insiderObject = new InsiderObjectDTO({
      ...properties,
      user: new InsiderUserDTO({
        ...(user && { ...user }),
        gdpr_optin: gdprOptin,
      })
    })
    this.logger.info('[Create] insider object: ', insiderObject)
    window.insider_object = insiderObject;
  }

  dispatchInsiderEvent(params: InsiderEventParams): void {
    this.logger.log(`[Dispatch] insider event: `, params);
    if (!window.Insider) {
      this.logger.info('[SDK]: ', 'Not found')
      return
    }

    const { event, properties } = params;
    window.Insider.track(event, properties)
    this.logger.info(`[Dispatch] insider event "${event}": `, properties)
  }
}
